import React from 'react'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../_metronic/helpers/components/KTIcon'

interface SidebarDocument {
  pageId: string
  title: string
  shortDescription: string
  order: number
  icon: string
}

interface SidebarCategory {
  name: string
  displayName: string
  icon: string
  order: number
  documents: SidebarDocument[]
}

interface Props {
  categories: SidebarCategory[]
  activePageId?: string
}

const HelpSidebar: React.FC<Props> = ({categories, activePageId}) => {
  if (categories.length === 0) return null

  return (
    <div className='card shadow-sm help-sidebar'>
      <div className='card-body p-4'>
        <h6 className='fw-bold text-gray-800 mb-4'>Documentation</h6>
        {categories.map((cat) => (
          <div key={cat.name} className='help-sidebar-category mb-1'>
            <div className='category-header category-header-static'>
              <div className='category-title'>
                <KTIcon iconName={(cat.icon || 'folder').replace(/^ki-/, '')} className='fs-4 text-gray-600' />
                <span>{cat.displayName}</span>
                <span className='badge badge-light-primary badge-sm'>
                  {cat.documents.length}
                </span>
              </div>
            </div>
            <ul className='category-docs'>
              {cat.documents.map((doc) => (
                <li key={doc.pageId}>
                  <Link
                    to={`/help/${doc.pageId}`}
                    className={`doc-link ${doc.pageId === activePageId ? 'active' : ''}`}
                  >
                    {doc.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export {HelpSidebar}
